import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import { useState } from "react";
import EquipmentGroupForm from "../../components/service/equipmentGroupForm.component";
import { useHasPermission } from "../../contexts/auth";

export const EquipmentGroupsListActions = () => {
  const { t } = useTranslation();
  const [addGroupOpened, setAddGroupOpened] = useState<boolean>(false);
  const canAddEquipmentGroup = useHasPermission("service.add_equipmentgroup");

  const actions: Action[] = [{
    id: "add-new-group",
    icon: <AddIcon />,
    label: t("Add new group"),
    onClick: () => { setAddGroupOpened(true) },
    disabled: !canAddEquipmentGroup
  }];

  const handleGroupAdded = () => {
    setAddGroupOpened(false);
  };

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addGroupOpened}
        setOpened={setAddGroupOpened}
        title={t("Add new group")}
        content={
          <EquipmentGroupForm onSuccess={handleGroupAdded} />
        }
      />
    </>
  );
};
